// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"_3WGBrmuUP54SyyXyLjEj5p","loader":"_2bWKTdHD6dRpRgUF4Ye0QC","loaderSmall":"Nuxni5OAwWfYxPR_f6izP"};